import { createSlice } from '@reduxjs/toolkit'

const initialTagState = {
  tag: null,
  tagsDropdown: [],
  assets: []
}

export const TagSlices = createSlice({
  name: 'tags',
  initialState: initialTagState,
  reducers: {
    tag: (state, action) => {
      state.tag = action.payload.tag
    },
    tagsDropdown: (state, action) => {
      state.tagsDropdown = action.payload.tags
    },
    assets: (state, action) => {
      state.assets = action.payload.assets
    }
  },
})